import { ArrowLeftIcon, IconButton } from '@paypalcorp/pp-react'
import React from 'react'

interface Props {
  backToUpdateGroup: () => void
}

const CloseGroupActions = ({ backToUpdateGroup }: Props) => {
  return (
    <IconButton
      svgIconComponent={ArrowLeftIcon}
      buttonType="tertiary"
      data-testid="goToUpdateGroupButton"
      onClick={backToUpdateGroup}
    />
  )
}

export default CloseGroupActions
